import { Fragment } from 'react';
import { Form } from 'react-bootstrap';
import DependentsAddress from './DependentsAddress';

function DependentsRows({ applicants, mssn, counties }) {

    return (
        applicants.map((applicant, index) =>
            <Fragment key={applicant.id}>
                <tr className="noBorder">
                    <td>
                        <Form.Group controlId={`applicant_Relationship_${index + 1}`} name="relationship" >
                            <Form.Select field="dependentOption" className='mb-2' defaultValue={applicant.type} readOnly required disabled>
                                <option hidden value="">Relationship</option>
                                <option value="Spouse" >Spouse</option>
                                <option value="Dependent">Dependent Child</option>
                                {/*<option value="child_of_dependent_child">Child of Dependent Child</option>*/}
                            </Form.Select>
                        </Form.Group>
                    </td>
                    <td className="d-flex centered">
                        <Form.Group controlId={`applicant_Sex_${index + 1}`} name="sex" >
                            <Form.Select className='mb-2' defaultValue={applicant.sex} readOnly required disabled>
                                <option hidden value="">Sex</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                            </Form.Select>
                        </Form.Group>
                    </td>
                    <td>
                        <Form.Group controlId={`applicant_Lastname_${index + 1}`} name="lastname">
                            <Form.Control type="text" className='mb-2' placeholder={`Last (Suffix)`} required />
                        </Form.Group>
                    </td>
                    <td>
                        <Form.Group controlId={`applicant_Firstname_${index + 1}`} name="firstname">
                            <Form.Control type="text" className='mb-2' placeholder={`First`} required />
                        </Form.Group>
                    </td>
                    <td>
                        <Form.Group controlId={`applicant_Middlename_${index + 1}`} name="middlename">
                            <Form.Control type="text" className='mb-2' placeholder={`Middle`} />
                        </Form.Group>
                    </td>
                    <td>
                        <Form.Group controlId={`applicant_Citizenship_${index + 1}`} name="citizenship" >
                            <Form.Select className='mb-2' required>
                                <option hidden value="">Citizenship</option>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </Form.Select>
                        </Form.Group>
                    </td>
                    <td>
                        <Form.Group controlId={`applicant_SSN_${index + 1}`} name="ssn">
                            <Form.Control type="text" className='mb-2' maxLength="11" pattern="^(\d{3}-?\d{2}-?\d{4}|XXX-XX-XXXX)$" placeholder="000-00-0000" onKeyUp={mssn} onBlur={mssn} required />
                        </Form.Group>
                    </td>
                    <td>
                        <Form.Group controlId={`applicant_DOB_${index + 1}`} name="dob" >
                            <Form.Control type="date" className='mb-2' value={applicant.dateOfBirth} readOnly required disabled />
                        </Form.Group>
                    </td>
                    <td>
                        <Form.Group controlId={`applicant_Tobacco_${index + 1}`} name="tobacco" >
                            <Form.Select className='mb-2' value={applicant.tobacco} readOnly required disabled>
                                <option hidden value="">Usage</option>
                                <option value={false}>No</option>
                                <option value={true}>Yes</option>
                            </Form.Select>
                        </Form.Group>
                        <input type="hidden" id={`applicant_Rate_${index + 1}`} value={applicant.rate} />
                    </td>
                </tr>
                <tr>
                    <td colSpan={9}>
                        <DependentsAddress id={index + 1} counties={counties} />
                    </td>
                </tr>
            </Fragment>
        )
    )
}

export default DependentsRows
